/* eslint-disable no-use-before-define */
import React from 'react'
import { useCalculator, } from './use-calculator'
import { isEmpty, SectionHeader, SectionBody } from '../twd'
import { CouponsFirstYear } from './calc-coupons/coupons-first-year'
import { CouponsByYear } from './calc-coupons/coupons-by-year'


export const CalcCoupons = () => {
    const {
        calcOutput, showCoupon, bondInfo
    } = useCalculator()

    const [show, setShow] = React.useState('first-year')
    const [showSection, setShowSection] = React.useState(showCoupon)

    React.useEffect(() => {
        if (!showCoupon) return

        setShowSection(true)
    }, [showCoupon])

    const isShow = bondInfo && bondInfo.canCalc
    if (!isShow) return null

    return <React.Fragment>
        <div className="row">
        <div className={"col-md-12"}>
            <SectionHeader
                title="Coupon payment schedules"
                cls="subhead"
                arrowSize='large'
                show={showSection}
                setShow={setShowSection}
            />
        </div>
        </div>

        <SectionBody show={showSection}>
        {isEmpty(calcOutput) && <React.Fragment>
            <div className='row vertical-offset-md'>
            <div className='col-xs-12 text-center'>
                <div className="vertical-offset-xs"><i className="et-icon-md et-icon et-alert" aria-hidden="true"></i></div>
                <div className="vertical-offset-xs">
                    <p className="small-header vertical-offset-xxs">Run calculation first</p>
                    <div className="text-body">Coupon payment schedules are generated from calculator data.</div>
                </div>
            </div>
            </div>
            </React.Fragment>}

        {!isEmpty(calcOutput) && <React.Fragment>
            <div className='row'>
            <div className='col-xs-12 nav-tabs nav-tabs-border'>
                <ul>
                <li className={show==='first-year' ? 'active' : ''}>
                    <button onClick={() => setShow('first-year')}>First 12 months</button>
                </li>
                <li className={show==='by-year' ? 'active' : ''}>
                    <button onClick={() => setShow('by-year')}>By year</button>
                </li>
                </ul>
            </div>
            </div>

            <div className='row'>
            <div className='col-md-12'>
            {show==='first-year' && <CouponsFirstYear />}
            {show==='by-year' && <CouponsByYear />}
            </div>
            </div>
        </React.Fragment>}
        </SectionBody>
       </React.Fragment>

}